import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { Events } from "./Constants";

var AppInsights =
/** @class */
function () {
  function AppInsights(insights, key, id, title) {
    this.applicationInsights = insights;
    this.title = title;
    this.key = key;
    this.id = id;
  }

  AppInsights.prototype.startTrackEvent = function (name) {
    if (!this.title || !this.applicationInsights) return;
    if (name) name = " - " + name;
    this.applicationInsights.startTrackEvent(this.title + name);
  };

  AppInsights.prototype.stopTrackEvent = function (name, additionalData) {
    if (!this.title || !this.applicationInsights) return;
    if (name) name = " - " + name;
    var customProperties = {
      additionalData: additionalData
    };
    this.applicationInsights.stopTrackEvent(this.title + name, customProperties);
  };

  AppInsights.prototype.track = function (type, additionalData) {
    if (!this.title || !this.applicationInsights) return;
    var customProperties = {
      additionalData: additionalData
    };

    switch (type) {
      case Events.Initialization:
        this.applicationInsights.trackEvent({
          name: this.title + " - Initialization"
        }, customProperties);
        break;

      case Events.Click:
        this.applicationInsights.trackEvent({
          name: this.title + " - Click"
        }, customProperties);
        break;

      case Events.Event:
        this.applicationInsights.trackEvent({
          name: this.title + " - Event"
        }, customProperties);
        break;

      case Events.Exception:
        this.applicationInsights.trackException({
          exception: new Error(this.title + " - Error"),
          severityLevel: SeverityLevel.Error
        }, customProperties);
        break;
    }
  };

  return AppInsights;
}();

export { AppInsights };